var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("picture", [
    _c("source", { attrs: { "data-srcset": _vm.webpUrl, type: "image/webp" } }),
    _vm._v(" "),
    _c("source", {
      attrs: { "data-srcset": _vm.imageUrl, type: "image/jpeg" }
    }),
    _vm._v(" "),
    _c("img", {
      staticClass: "d-block mx-auto mw-100",
      attrs: {
        "data-src": _vm.imageUrl,
        width: "250",
        height: "250",
        alt: "teaser"
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }